import moment from 'moment';
import React from 'react';

import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { getDeliveriesColor, getColorsFromCssClassName } from '../../helpers/ColorRules';
import DocumentHelper from '../../helpers/Document';

class TrackMap extends React.Component {

    constructor(props) {
        super(props);

        this.markers = [];

        this.state = {
            active_document: null
        }
    }

    componentDidMount() {
        this.startMap();
    }

    startMap() {
        const google = window.google;
        const polibras = { lat: -13.5279162, lng: -51.6724931 };

        this.map = new google.maps.Map(this.refs.map, {
          zoom: 4,
          center: polibras
        });

        this.props.onMapInit(this.map);

        this.addMarkers(this.props, true);
    }

    componentWillReceiveProps(props) {
        this.clearMarkers();
        this.addMarkers(props, false);
    }

    addMarkers(props, fit) {
        const map = this.map;
        const google = window.google;
        const bounds = new google.maps.LatLngBounds();

        const document_store = props.document_store;
        const documents = DocumentHelper.mapByStatus(document_store.documents, 'active');

        documents.forEach(document => {
            const location = document.location;

            if (location) {
                const { latitude, longitude } = location;
                const position = { lat: latitude, lng: longitude };

                bounds.extend(position);

                this.addMarker(position, document);
            }

            const active_document = this.state.active_document;

            if (active_document && active_document.id === document.id) {
                this.setState({ active_document: document });
            }
        });

        if (fit) {
            map.fitBounds(bounds);
        }
    }

    addMarker(position, document) {
        const google = window.google;
        const map = this.map;

        const icon = this.getIcon(document);
        const marker = new google.maps.Marker({position, map, icon});
        this.markers.push(marker);

        marker.addListener('click', this.props.onClickMarker.bind(this, marker, document));
    }

    getIcon(document) {
        const parcial = document.parcial || {done: 0, total: 0, percent: 100};
        const class_name_rule = getDeliveriesColor(parcial);
        let color = getColorsFromCssClassName(class_name_rule);
        const location = document.location;

        const updated_at = moment(location.datetime);
        const now = moment();

        const diff = now.diff(updated_at, 'days');

        if (diff >= 1) {
            color = '#999';
        }

        return {
            url: `data:image/svg+xml;utf-8,<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="23.25px" height="22.667px" viewBox="0 0 23.25 22.667" enable-background="new 0 0 23.25 22.667" xml:space="preserve"> <circle fill="#FFFFFF" stroke="${color}" stroke-width="6" stroke-miterlimit="10" cx="11.75" cy="11.317" r="8"/></svg>`
        }
    }

    clearMarkers() {
        this.markers.forEach(marker => {
            marker.setMap(null);
        });
    }

    render() {
        const document_store = this.props.document_store;

        return (
            <div
                data-last-sync={document_store.updated_at.toString()}
                ref="map"
                className="map">
            </div>
        );
    }

}

let container = observer(TrackMap);
container = inject(['document_store'])(container);

export default withRouter(container);



// WEBPACK FOOTER //
// ./src/components/Track/Map.js